<template>
  <div>
    <div class="center" v-if="showLoading">
      <lottie :options="defaultOptionsSplashScreen" :height="300" :width="300" v-on:animCreated="handleAnimationSplashScreen"/>
    </div>
    <div v-else>
      <headerSection></headerSection>
      <div id="main__content" class="">
        <div class="x-main-container">
          <div class="x-main-content">
            <div class="x-promotion-index" :style="{'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
              <div class="container">
                <div class="row">
                  <div class="col-12">
                    <div class="x-page-title-component -long-support">
                      <div class="-inner-wrapper">
                        <h1 class="-title redeem-title">กรอก Code รับเครดิต</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-6">
                    <!-- REDEEM CARD -->
                    <div class="redeem-card">
                      <div class="redeem-icon">
                        <i class="fa fa-gift"></i>
                      </div>
                      <p class="redeem-desc">กรอก Reward Code ที่ได้รับจากการทายผลบอล</p>

                      <div class="code-input-wrapper">
                        <input
                          type="text"
                          v-model="inputCode"
                          class="code-input"
                          placeholder="______"
                          maxlength="6"
                          :disabled="isRedeeming"
                          @input="inputCode = inputCode.toUpperCase()"
                        />
                        <div class="input-underline"></div>
                      </div>

                      <button
                        class="redeem-btn"
                        @click="redeemCode"
                        :disabled="isRedeeming || inputCode.length !== 6"
                      >
                        <span v-if="isRedeeming">
                          <i class="fa fa-spinner fa-spin mr-2"></i>กำลังรับรางวัล...
                        </span>
                        <span v-else>
                          <i class="fa fa-check-circle mr-2"></i>รับรางวัล
                        </span>
                      </button>
                    </div>

                    <!-- INFO CARD -->
                    <div class="info-card mt-4">
                      <h5><i class="fa fa-info-circle mr-2"></i>วิธีใช้</h5>
                      <ol>
                        <li>ทายผลบอลและชนะเพื่อรับ Reward Code</li>
                        <li>Admin จะส่ง Code 6 ตัวให้คุณ</li>
                        <li>กรอก Code ที่นี่เพื่อรับเครดิต</li>
                        <li>แต่ละ Code ใช้ได้ครั้งเดียวเท่านั้น</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footerSection></footerSection>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
import router from './../router'
import Lottie from './lottie.vue'
import * as animateSantaWalk from '../assets/loading.json'

export default {
  name: 'RedeemCode',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    lottie: Lottie
  },
  data() {
    return {
      showLoading: true,
      defaultOptionsSplashScreen: null,
      inputCode: '',
      isRedeeming: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user.user
    }
  },
  created() {
    const user = localStorage.getItem('userData')
    if (user) {
      const _user = JSON.parse(user)
      this.$store.dispatch('user/setUser', _user).catch(err => { console.error(err) })
    } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
    }

    const animateSplashScreen = animateSantaWalk.default
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  mounted() {
    this.animSplashScreen && this.animSplashScreen.play()
    setTimeout(() => {
      this.showLoading = false
      this.animSplashScreen && this.animSplashScreen.stop()
    }, 2000)
  },
  methods: {
    handleAnimationSplashScreen(anim) {
      this.animSplashScreen = anim
    },
    async redeemCode() {
      if (this.isRedeeming) return
      if (this.inputCode.length !== 6) {
        this.$swal('แจ้งเตือน', 'กรุณากรอก Code 6 ตัว', 'warning')
        return
      }

      this.isRedeeming = true

      try {
        // Call Cloud Function (asia-east2 region)
        const redeemRewardCode = firebase.app().functions('asia-east2').httpsCallable('redeemRewardCode')
        const result = await redeemRewardCode({
          code: this.inputCode.toUpperCase(),
          user_key: this.user.key
        })

        if (result.data.success) {
          this.$swal(
            'สำเร็จ!',
            `รับเครดิตสำเร็จ! ได้รับ ${result.data.net_profit} บาท`,
            'success'
          )
          this.inputCode = ''
        }
      } catch (error) {
        console.error('Redeem code error:', error)
        let errorMessage = 'ไม่สามารถใช้ Code ได้'

        if (error.code === 'not-found') {
          errorMessage = 'ไม่พบ Code นี้'
        } else if (error.code === 'already-exists') {
          errorMessage = 'Code ถูกใช้แล้ว'
        } else if (error.code === 'permission-denied') {
          errorMessage = 'Code นี้ไม่ใช่ของคุณ'
        } else if (error.message) {
          errorMessage = error.message
        }

        this.$swal('เกิดข้อผิดพลาด', errorMessage, 'error')
      } finally {
        this.isRedeeming = false
      }
    }
  }
}
</script>

<style scoped>
/* Purple/Gold Gradient Theme */
.redeem-title {
  font-size: 24px;
  color: #fbc844;
  text-shadow: 0 0 20px rgba(251, 200, 68, 0.5);
}

/* Redeem Card */
.redeem-card {
  background: linear-gradient(180deg, #492666, #8309a2);
  border: 2px solid #fbc844;
  border-radius: 20px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 5px 40px rgba(131, 9, 162, 0.4);
}

.redeem-icon {
  font-size: 60px;
  color: #fbc844;
  margin-bottom: 20px;
  text-shadow: 0 0 30px rgba(251, 200, 68, 0.5);
}

.redeem-desc {
  color: #fff;
  font-size: 16px;
  margin-bottom: 30px;
}

/* Code Input */
.code-input-wrapper {
  position: relative;
  margin-bottom: 30px;
}

.code-input {
  width: 100%;
  padding: 20px;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 15px;
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(251, 200, 68, 0.4);
  border-radius: 15px;
  color: #fbc844;
  text-transform: uppercase;
  transition: all 0.3s ease;
}

.code-input::placeholder {
  color: rgba(255, 255, 255, 0.3);
  letter-spacing: 20px;
}

.code-input:focus {
  outline: none;
  border-color: #fbc844;
  box-shadow: 0 0 20px rgba(251, 200, 68, 0.3);
}

.code-input:disabled {
  opacity: 0.6;
}

/* Redeem Button */
.redeem-btn {
  background: linear-gradient(180deg, #ba7f24, #fbc844);
  border: none;
  border-radius: 12px;
  padding: 18px 50px;
  font-size: 18px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 300px;
  box-shadow: 0 5px 20px rgba(186, 127, 36, 0.4);
}

.redeem-btn:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 8px 30px rgba(251, 200, 68, 0.5);
}

.redeem-btn:disabled {
  background: #555;
  color: #888;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Info Card */
.info-card {
  background: linear-gradient(180deg, rgba(73, 38, 102, 0.8), rgba(131, 9, 162, 0.7));
  border: 1px solid rgba(251, 200, 68, 0.2);
  border-radius: 12px;
  padding: 20px;
  color: #fff;
  margin-bottom: 30px;
}

.info-card h5 {
  color: #fbc844;
  margin-bottom: 15px;
  font-size: 16px;
}

.info-card ol {
  margin: 0;
  padding-left: 25px;
}

.info-card li {
  margin-bottom: 10px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
}

/* Mobile Responsive */
@media (max-width: 576px) {
  .redeem-card {
    padding: 30px 20px;
  }

  .code-input {
    font-size: 28px;
    letter-spacing: 10px;
    padding: 15px;
  }

  .code-input::placeholder {
    letter-spacing: 15px;
  }

  .redeem-icon {
    font-size: 50px;
  }

  .redeem-btn {
    padding: 15px 30px;
    font-size: 16px;
    max-width: 100%;
  }
}
</style>
